export default "__VITE_ASSET__VzhbwD5c__"